import { GetFromLocalStorage, SaveToLocalStorage } from "./LocalStorage";

export type TrackingConsent = "accepted" | "declined";

const CONSENT_KEY = "tracking_consent";
const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID || "G-L90QK0NH5D";

export const getTrackingConsent = (): TrackingConsent | null => {
  const value = GetFromLocalStorage(CONSENT_KEY);
  if (value === "accepted" || value === "declined") return value;
  return null;
};

export const setTrackingConsent = (value: TrackingConsent): void => {
  SaveToLocalStorage(CONSENT_KEY, value);
};

export const hasAcceptedTracking = (): boolean => {
  return getTrackingConsent() === "accepted";
};

export const shouldShowConsentBanner = (): boolean => {
  return getTrackingConsent() === null;
};

/**
 * Dynamically loads and initializes Google Analytics.
 * Safe to call multiple times — guards against duplicate script injection.
 */
export const loadGoogleAnalytics = (): void => {
  if (typeof window === "undefined") return;
  if ((window as any).__gaLoaded) return;

  (window as any).__gaLoaded = true;

  // Initialize dataLayer and gtag stub before the script loads
  (window as any).dataLayer = (window as any).dataLayer || [];
  function gtag(...args: any[]) {
    (window as any).dataLayer.push(args);
  }
  (window as any).gtag = gtag;
  gtag("js", new Date());
  gtag("config", GA_MEASUREMENT_ID);

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);
};
